/**
 * Add Roadmap Item UseCase
 *
 * Thin delegator for submitting a new roadmap (Ideas) item. Forwards the
 * title, description and current-user author to `roadmapService.addRoadmapItem`
 * and returns its success boolean unchanged. No business logic lives here —
 * the `RoadmapItem` field building (id/order/status/counters/timestamps) and
 * the Cloud Function payload stay in the service.
 *
 * Flutter parity:
 *  - lib/presentation/screens/roadmap/add_roadmap_item_screen.dart:108
 *    (_submitRoadmapItem): `RoadmapRepository().addRoadmapItem(item)` returns a
 *    `bool success`. Flutter calls the repository directly; the web wraps it in
 *    this use case per conventions.md Clean-Architecture flow.
 */

import { roadmapService } from '@/domain/services/roadmap/roadmapService';
import type { RoadmapItemAuthor } from '@/domain/input/roadmap/roadmapItemAuthor';

export class AddRoadmapItemUseCase {
  async execute(
    title: string,
    description: string,
    currentUser: RoadmapItemAuthor,
  ): Promise<boolean> {
    return roadmapService.addRoadmapItem(title, description, currentUser);
  }
}

export const addRoadmapItemUseCase = new AddRoadmapItemUseCase();
